import {
  ColumnChooser,
  ColumnDirective,
  ColumnsDirective,
  EditSettingsModel,
  ExcelExport,
  GridComponent,
  Group,
  Inject,
} from '@syncfusion/ej2-react-grids';
import {
  Edit,
  Toolbar,
  FilterSettingsModel,
  Filter,
  PageSettingsModel,
  Page,
  ColumnMenu,
  Resize,
} from '@syncfusion/ej2-react-grids';
import {
  DialogComponent,
  AnimationSettingsModel,
  ButtonPropsModel,
} from '@syncfusion/ej2-react-popups';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import * as React from 'react';
import './dialog.css';
import { ThemeContext } from '../../context/theme.context';
import { FaCopy, FaMinus, FaPlus } from 'react-icons/fa';
import { IconContext } from 'react-icons/lib';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { loadingShow } from '../../App';
import { toast } from 'react-toastify';
import Message from '../../utils/Message/Message';
import {
  AddRosterTemplate,
  GetRostersTemplate,
  deleteTemplate,
  editTemplate,
} from '../../services/Settings/RostersTemplate';
import { GetRosters } from '../../services/Settings/Roster';
interface IState {
  hideDialog: boolean;
  weeksValue: number;
  TemplateData: Object;
  roosterData: Array<any>;
  list: Array<JSX.Element>;
  dayGrid: Array<any>;
  minus: boolean;
  plus: boolean;
  weekDay: { day: string; id: number }[];
  isEnableCopy: boolean;
  editDialog: boolean;
  hideDialogDelete: boolean;
  pickedTemplateId: any;
  contentOfTheWeek: any;
}
export default class TableRosterTemplate extends React.Component<{}, IState> {
  static contextType = ThemeContext;
  context!: React.ContextType<typeof ThemeContext>;
  public editOptions: EditSettingsModel = {
    allowEditing: false,
    allowAdding: false,
    allowDeleting: true,
    allowEditOnDblClick: true,
    showConfirmDialog: true,
    showDeleteConfirmDialog: true,
  };
  public toolbarOptions = [
    {
      text: 'Add',
      tooltipText: 'Add',
      prefixIcon: 'e-add',
      id: 'add',
    },
    {
      text: 'Edit',
      tooltipText: 'Edit',
      prefixIcon: 'e-edit',
      id: 'edit',
    },
    {
      text: 'Delete',
      tooltipText: 'Delete',
      prefixIcon: 'e-delete',
      id: 'delete',
    },
    'ColumnChooser',
    'ExcelExport',
    'Search',
  ];
  public FilterOptions: FilterSettingsModel = { type: 'Menu' };
  public pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 12,
    pageCount: 8,
    pageSizes: true,
  };

  private grid: any;
  private buttons: ButtonPropsModel[];
  private buttonsForEdit: ButtonPropsModel[];
  private animationSettings: AnimationSettingsModel;
  private WeeksDataNumber: any[];
  private list: Array<JSX.Element>;
  private actionData: Array<any>;
  private tempActionData: Array<any>;
  private fields: object = { text: 'rosterCode' };
  private tempValue: number = -1;
  private name: string;
  private description: string;
  private fieldsDay = { text: 'day', value: 'id' };
  private startDay = 6;
  private buttonsDelete: ButtonPropsModel[];
  private pickedTemplateId: Number = 0;
  private shift_template_id: Number = 0;
  private weekStartByNumber: number = -1;
  private theDays = [
    {
      day: 'Sunday',
      id: 0,
    },
    {
      day: 'Monday',
      id: 1,
    },
    {
      day: 'Tuesday',
      id: 2,
    },
    {
      day: 'Wednesday',
      id: 3,
    },
    {
      day: 'Thursday',
      id: 4,
    },
    {
      day: 'Friday',
      id: 5,
    },
    {
      day: 'Saturday',
      id: 6,
    },
  ];
  private initialRenderWeek: boolean = false;
  private isAdd: boolean = false;
  constructor(props: {}) {
    super(props);
    this.grid = new GridComponent(props);
    this.animationSettings = { effect: 'Zoom', duration: 400, delay: 0 };
    this.WeeksDataNumber = [1, 2, 3, 4];
    this.buttonsDelete = [
      {
        click: () => {
          this.deleteTemplate();
        },
        buttonModel: {
          content: 'Yes',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ hideDialogDelete: false });
        },
        buttonModel: {
          content: 'No',
        },
      },
    ];
    this.buttons = [
      {
        click: () => {
          if (this.isAdd) {
            this.saveTemplate();
          } else {
            this.edit();
          }
        },
        buttonModel: {
          content: 'Save',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ hideDialog: false });
        },
        buttonModel: {
          content: 'Cancel',
        },
      },
    ];
    this.buttonsForEdit = [
      {
        click: () => {
          this.edit();
        },
        buttonModel: {
          content: 'Save',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ editDialog: false });
        },
        buttonModel: {
          content: 'Cancel',
        },
      },
    ];
    this.state = {
      pickedTemplateId: '',
      hideDialogDelete: false,
      hideDialog: false,
      weeksValue: 4,
      TemplateData: [],
      roosterData: [],
      list: [],
      dayGrid: [
        {
          order: 1,
        },
        {
          order: 2,
        },
      ],
      plus: true,
      minus: false,
      weekDay: [
        {
          day: 'Sunday',
          id: 0,
        },
        {
          day: 'Monday',
          id: 1,
        },
        {
          day: 'Tuesday',
          id: 2,
        },
        {
          day: 'Wednesday',
          id: 3,
        },
        {
          day: 'Thursday',
          id: 4,
        },
        {
          day: 'Friday',
          id: 5,
        },
        {
          day: 'Saturday',
          id: 6,
        },
      ],
      isEnableCopy: true,
      editDialog: false,
      contentOfTheWeek: undefined,
    };
    this.actionData = [];
    this.tempActionData = [];
    this.list = [];
    this.name = '';
    this.description = '';
  }
  edit = () => {
    loadingShow(true, 'Editing...');
    const obj = {
      rt_description: this.description,
      rt_id: this.shift_template_id,
      rt_week: this.state.weeksValue,
      rt_weekstart: this.tempValue,
      rt_template_name: this.name,
      shiftTemplateDetail: this.actionData.map((el) => {
        return {
          ...el,
          description: this.description,
          rt_id: this.shift_template_id,
          week: this.state.weeksValue,
          weekstart: this.startDay,
          template_name: this.name,
        };
      }),
    };
    editTemplate(obj)
      .then((e) => {
        loadingShow(false);
        Message.success('Edit is success');
        this.getShiftTemplate();
        this.setState({ hideDialog: false });
      })
      .catch((e) => {
        loadingShow(false);
        Message.success('Edit has failed');
        //(e);
      });
  };
  saveTemplate = () => {
    const weekNumber = this.state.weeksValue;
    const weekstart = this.startDay;
    const name = this.name;
    const desc = this.description;
    loadingShow(true, 'Saving');
    if (name === '') {
      toast.error('Name cannot be empty');
      loadingShow(false, 'Saving');
      return;
    }
    if (desc === '') {
      toast.error('Description cannot be empty');
      loadingShow(false, 'Saving');
      return;
    }
    const obj = {
      rt_week: weekNumber,
      rt_weekstart: this.tempValue,
      rt_description: this.description,
      rt_template_name: this.name,
      shiftTemplateDetail: this.actionData.map((el) => {
        return {
          ...el,
          description: this.description,
          rt_id: this.shift_template_id,
          week: this.state.weeksValue,
          weekstart: this.startDay,
          template_name: this.name,
        };
      }),
    };
    AddRosterTemplate(obj)
      .then((response) => {
        loadingShow(false, 'Saving');
        toast.success('Save is success');
        this.actionData = [];
        this.setState({ hideDialog: false });
        this.getRooster();
        this.description = '';
        this.name = '';
        this.getShiftTemplate();
      })
      .catch((e) => {
        loadingShow(false, 'Saving');
        //(e);
        toast.error('Error occured. Try again later');
      });
  };
  componentDidMount() {
    this.getRooster();
    this.getShiftTemplate();
  }
  componentDidUpdate(
    prevProps: Readonly<{}>,
    prevState: Readonly<IState>,
    snapshot?: any
  ): void {
    if (
      prevState.weeksValue !== this.state.weeksValue ||
      prevState.minus !== this.state.minus ||
      prevState.plus !== this.state.plus ||
      prevState.weekDay !== this.state.weekDay
    ) {
      this.setState({ contentOfTheWeek: this.renderWeeks() });
      this.setState({ hideDialog: true });
    }
    if (this.context.isDataChangeShiftTemplate) {
      this.getRooster();
      this.context.setDataChangeShiftTemplate(false);
    }
  }
  deleteTemplate() {
    var templateID = this.pickedTemplateId;
    if (templateID === 0) {
      toast.error('Team was not selected be empty');
      loadingShow(false);
      return false;
    }
    let obj = {
      rt_id: Number(templateID),
    };
    loadingShow(true, 'Deleting...');
    deleteTemplate(obj)
      .then((result) => {
        loadingShow(false);
        Message.success('Deleted  successfully...');
        this.getShiftTemplate();
        this.dialogClose();
      })
      .catch((err) => {
        loadingShow(false);
        Message.error('Operation failed!!!');
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
      });
    this.dialogCloseDelete();
  }

  dialogOpenDelete(): void {
    this.setState({ hideDialogDelete: true });
  }
  dialogCloseDelete(): void {
    this.setState({
      hideDialogDelete: false,
    });
  }
  getShiftTemplate() {
    GetRostersTemplate().then((result) => {
      var model = result.data.map((res: any) => {
        return {
          ...res,
          rt_row_detail: res.shiftTemplateDetail,
          Assignees: '...',
        };
      });
      this.setState({ TemplateData: model });
    });
  }
  getRooster() {
    GetRosters()
      .then((data: any) => {
        const customData = data.data.filter((e: any) => {
          return e.isrostered;
        });
        customData.unshift({ rosterCode: '', rostercolor: '' });
        this.setState({ roosterData: customData });
      })
      .catch((e) => {
        //(e);
      });
  }
  dialogClose(): void {
    this.setState({ hideDialog: false });
  }
  dialogOpen(): void {
    // this.actionData = [];
    this.setState({
      hideDialog: true,
    });
  }
  itemTemplate(data: any): JSX.Element {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginTop: '5px',
          marginLeft: '5px',
        }}
      >
        <div
          style={{
            backgroundColor: data.rostercolor,
            width: '20px',
            height: '20px',
            borderRadius: '5px',
          }}
        ></div>
        <span>{data.rosterCode}</span>
      </div>
    );
  }
  begin(args: any) {
    if (args.requestType === 'beginEdit') {
      alert('edit');
    }
    if (args.requestType === 'save') {
      alert('save');
    }
  }
  toolbarClick(args: any) {
    if (args.item.id === 'add') {
      this.isAdd = true;
      this.setState({ hideDialog: true, contentOfTheWeek: this.renderWeeks() });
    }
    if (args.item.id === 'delete') {
      var selectedId = this.grid.getSelectedRecords()[0].rt_id;
      this.pickedTemplateId = Number(selectedId);
      //(selectedId);
      this.dialogOpenDelete();
    }
    if (args.item.id === 'edit') {
      if (this.grid.getSelectedRecords().length !== 0) {
        this.isAdd = false;
        var selectedData = this.grid.getSelectedRecords()[0];
        this.actionData = selectedData.rt_row_detail;
        this.shift_template_id = selectedData.rt_id as Number;
        const des = selectedData.rt_description;
        const name = selectedData.rt_template_name;
        const weekOfNumber = Number(selectedData.rt_week);
        this.weekStartByNumber = selectedData.rt_weekstart;
        this.tempValue = this.weekStartByNumber;
        const temp = Object.create(this.theDays);
        const parseTemp = temp.splice(Number(this.weekStartByNumber));
        parseTemp.push(...temp);
        this.name = name;
        this.description = des;
        this.setState({
          hideDialog: true,
          weekDay: parseTemp,
          weeksValue: weekOfNumber,
        });
      } else {
        alert('no records selected for edit operation');
      }
    }
    if (args.item.id === 'refresh') {
      this.getShiftTemplate();
    }
    if (this.grid && args.item.id === 'gridShiftTemplate_excelexport') {
      this.grid.excelExport();
    }
  }
  Onchange(args: any) {
    let condMin;
    let condPlus;
    let disableCoppy;
    if (args.value === 1) {
      condMin = true;
      condPlus = false;
      disableCoppy = false;
    }
    if (args.value === 4) {
      condPlus = true;
      condMin = false;
      disableCoppy = true;
    }
    if (args.value !== 1 && args.value !== 4) {
      condMin = false;
      condPlus = false;
      disableCoppy = false;
    }
    this.setState({
      hideDialog: false,
      weeksValue: args.value,
      minus: condMin as boolean,
      plus: condPlus as boolean,
      isEnableCopy: disableCoppy as boolean,
    });
  }
  onChangeWeekStartDat(e: any) {
    const temp = [...this.theDays];
    const parseTemp = temp.splice(e.value);
    parseTemp.push(...temp);
    this.tempValue = e.value;
    this.setState({
      weekDay: parseTemp,
      hideDialog: false,
      contentOfTheWeek: this.renderWeeks(),
    });
  }
  changeDrop(e: any) {
    const incomming = e.target.id;
    const currentData = e.value;
    const index = this.actionData.findIndex(
      (e) => e.day_sequence?.toString()?.toString() === incomming
    );
    this.actionData[index].shift = currentData;
  }
  componentWillUnmount() {}
  copyLine(row: number) {
    const targetIndex = this.state.weeksValue + 1;
    var theCounter = 0;
    if (this.actionData.length != 0) {
      for (var i = 1; i <= targetIndex; i++) {
        for (var j = 1; j <= 7; j++) {
          this.actionData[theCounter] !== undefined
            ? this.tempActionData.push(this.actionData[theCounter])
            : this.tempActionData.push({ day_sequence: i + '' + j, shift: '' });
          theCounter++;
        }
      }
      theCounter = 0;
      this.actionData = [];
      this.actionData.push(...this.tempActionData);
      this.tempActionData = [];
    } else {
      for (var k = 1; k <= targetIndex; k++) {
        for (var m = 1; m <= 7; m++) {
          const theNum = k + '' + m;
          const theObj = { day_sequence: theNum, shift: '' };
          this.actionData.push(theObj);
        }
      }
    }
    const startFromCopyIndex = (row - 1) * 7;
    const startToCopyIndex = (targetIndex - 1) * 7;
    for (var i = 0; i < 7; i++) {
      this.actionData[startToCopyIndex + i].shift =
        this.actionData[startFromCopyIndex + i].shift;
    }
    let isCopyDisable = false;
    if (targetIndex === 4) {
      isCopyDisable = true;
    }
    this.setState({
      weeksValue: targetIndex,
      isEnableCopy: isCopyDisable,
      hideDialog: false,
      plus: targetIndex === 4,
      minus: targetIndex === 1,
    });
  }
  rowTemplate(row: number) {
    return (
      <tr
        style={{
          backgroundColor: this.context.isDarkMode ? '#15202B' : 'white',
          color: 'white',
        }}
        id={row + ' ' + Math.random()}
      >
        <td
          style={{
            backgroundColor: this.context.isDarkMode ? '#15202B' : 'white',
            color: 'white',
          }}
        >
          {row}
        </td>
        <td>
          {' '}
          <DropDownListComponent
            id={'' + row + '1'}
            dataSource={this.state.roosterData}
            placeholder='Select a Roster'
            onChange={this.changeDrop.bind(this)}
            itemTemplate={this.itemTemplate.bind(this)}
            fields={this.fields}
            valueTemplate={this.itemTemplate.bind(this)}
            value={
              this.actionData[
                this.actionData.findIndex(
                  (e) => e.day_sequence?.toString() === '' + row + '1'
                )
              ]?.shift
            }
            width={'150px'}
          />{' '}
        </td>
        <td>
          {' '}
          <DropDownListComponent
            id={'' + row + '2'}
            dataSource={this.state.roosterData}
            placeholder='Select a Roster'
            onChange={this.changeDrop.bind(this)}
            itemTemplate={this.itemTemplate.bind(this)}
            fields={this.fields}
            valueTemplate={this.itemTemplate.bind(this)}
            value={
              this.actionData[
                this.actionData.findIndex(
                  (e) => e.day_sequence?.toString() === '' + row + '2'
                )
              ]?.shift
            }
            width={'150px'}
          />{' '}
        </td>
        <td>
          {' '}
          <DropDownListComponent
            id={'' + row + '3'}
            dataSource={this.state.roosterData}
            placeholder='Select a Roster'
            onChange={this.changeDrop.bind(this)}
            itemTemplate={this.itemTemplate.bind(this)}
            fields={this.fields}
            valueTemplate={this.itemTemplate.bind(this)}
            value={
              this.actionData[
                this.actionData.findIndex(
                  (e) => e.day_sequence?.toString() === '' + row + '3'
                )
              ]?.shift
            }
            width={'150px'}
          />{' '}
        </td>
        <td>
          {' '}
          <DropDownListComponent
            id={'' + row + '4'}
            dataSource={this.state.roosterData}
            placeholder='Select a Roster'
            onChange={this.changeDrop.bind(this)}
            itemTemplate={this.itemTemplate.bind(this)}
            fields={this.fields}
            valueTemplate={this.itemTemplate.bind(this)}
            value={
              this.actionData[
                this.actionData.findIndex(
                  (e) => e.day_sequence?.toString() === '' + row + '4'
                )
              ]?.shift
            }
            width={'150px'}
          />{' '}
        </td>
        <td>
          {' '}
          <DropDownListComponent
            id={'' + row + '5'}
            dataSource={this.state.roosterData}
            placeholder='Select a Roster'
            onChange={this.changeDrop.bind(this)}
            itemTemplate={this.itemTemplate.bind(this)}
            fields={this.fields}
            valueTemplate={this.itemTemplate.bind(this)}
            value={
              this.actionData[
                this.actionData.findIndex(
                  (e) => e.day_sequence?.toString() === '' + row + '5'
                )
              ]?.shift
            }
            width={'150px'}
          />{' '}
        </td>
        <td>
          {' '}
          <DropDownListComponent
            id={'' + row + '6'}
            dataSource={this.state.roosterData}
            placeholder='Select a Roster'
            onChange={this.changeDrop.bind(this)}
            itemTemplate={this.itemTemplate.bind(this)}
            fields={this.fields}
            valueTemplate={this.itemTemplate.bind(this)}
            value={
              this.actionData[
                this.actionData.findIndex(
                  (e) => e.day_sequence?.toString() === '' + row + '6'
                )
              ]?.shift
            }
            width={'150px'}
          />{' '}
        </td>
        <td>
          {' '}
          <DropDownListComponent
            id={'' + row + '7'}
            dataSource={this.state.roosterData}
            placeholder='Select a Roster'
            onChange={this.changeDrop.bind(this)}
            itemTemplate={this.itemTemplate.bind(this)}
            fields={this.fields}
            valueTemplate={this.itemTemplate.bind(this)}
            value={
              this.actionData[
                this.actionData.findIndex(
                  (e) => e.day_sequence?.toString() === '' + row + '7'
                )
              ]?.shift
            }
            width={'150px'}
          />{' '}
        </td>
        <td>
          {' '}
          <button
            className='copyButton'
            style={{ backgroundColor: 'transparent', border: 'none' }}
            onClick={this.copyLine.bind(this, row)}
            disabled={this.state.isEnableCopy}
          >
            <IconContext.Provider
              value={{
                color: this.context.isDarkMode
                  ? this.state.isEnableCopy
                    ? '#a39e9e'
                    : '#fcfafa'
                  : this.state.isEnableCopy
                  ? '#a39e9e'
                  : '#686968',
              }}
            >
              <FaCopy className='' />
            </IconContext.Provider>
          </button>{' '}
        </td>
      </tr>
    );
  }
  renderWeeks = () => {
    this.list = [];
    var theCounter = 0;
    if (this.actionData.length != 0) {
      for (var i = 1; i <= this.state.weeksValue; i++) {
        for (var j = 1; j <= 7; j++) {
          this.actionData[theCounter] !== undefined
            ? this.tempActionData.push(this.actionData[theCounter])
            : this.tempActionData.push({ day_sequence: i + '' + j, shift: '' });
          theCounter++;
        }
      }
      theCounter = 0;
      this.actionData = [];
      this.actionData.push(...this.tempActionData);
      this.tempActionData = [];
    } else {
      for (var i = 1; i <= this.state.weeksValue; i++) {
        for (var j = 1; j <= 7; j++) {
          const theNum = i + '' + j;
          const theObj = { day_sequence: theNum, shift: '' };
          this.actionData.push(theObj);
        }
      }
    }

    for (var i = 1; i <= this.state.weeksValue; i++) {
      this.list.push(this.rowTemplate(i));
    }
    this.initialRenderWeek = true;
    return this.list;
  };

  increase() {
    var temp = this.state.weeksValue;

    if (this.state.weeksValue >= 3) {
      this.setState({
        plus: true,
        minus: false,
        weeksValue: ++temp,
        isEnableCopy: true,
        hideDialog: false,
      });
    } else {
      this.setState({
        weeksValue: ++temp,
        hideDialog: false,
        plus: false,
        minus: false,
      });
    }
  }
  decrease() {
    var temp = this.state.weeksValue;
    if (this.state.weeksValue <= 2) {
      this.setState({
        minus: true,
        plus: false,
        weeksValue: --temp,
        contentOfTheWeek: this.renderWeeks(),
        hideDialog: false,
      });
    } else {
      this.setState({
        weeksValue: --temp,
        plus: false,
        isEnableCopy: false,
        hideDialog: false,
      });
    }
  }

  dialogComponentContent = () => {
    const myStyle = {
      backgroundColor: this.context.isDarkMode ? '#15202B' : 'white',
      color: this.context.isDarkMode ? 'white' : '#15202B',
    };
    return (
      <div className='container'>
        <div className='row mb-12'>
          <div className='col-md-1' style={{ marginTop: 10 }}>
            <strong># of Weeks</strong>
          </div>
          <div className='col-md-2' style={{ marginTop: 3 }}>
            <DropDownListComponent
              id='ddlelement'
              dataSource={this.WeeksDataNumber}
              change={this.Onchange.bind(this)}
              placeholder='4'
              value={this.state.weeksValue}
            />
          </div>
          <div className='col-md-2' style={{ marginTop: 3 }}>
            <DropDownListComponent
              placeholder={'Select Start Day'}
              dataSource={this.theDays}
              onChange={this.onChangeWeekStartDat.bind(this)}
              value={this.tempValue}
              fields={this.fieldsDay}
            />
          </div>
          <div
            className='col-md-2'
            style={{ position: 'relative', bottom: 20 }}
          >
            <TextBoxComponent
              placeholder='Name'
              cssClass='e-outline'
              floatLabelType='Auto'
              value={this.name}
              onChange={(e: any) => {
                this.name = e.value;
              }}
            />
          </div>
          <div
            className='col-md-2'
            style={{ position: 'relative', bottom: 20 }}
          >
            <TextBoxComponent
              placeholder='Description'
              cssClass='e-outline'
              floatLabelType='Auto'
              value={this.description}
              onChange={(e: any) => {
                this.description = e.value;
              }}
            />
          </div>
        </div>
        <div className='row mb-3'>
          <table
            className='table table-bordered table-striped table-hover'
            style={myStyle}
          >
            <thead>
              <tr>
                <td style={myStyle} colSpan={1}>
                  Weeks
                </td>
                <td style={myStyle} colSpan={7}>
                  Days
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={myStyle}>#</td>
                {this.state.weekDay.map((e2) => {
                  return <td style={myStyle}>{e2.day}</td>;
                })}
              </tr>
              {this.state.contentOfTheWeek}
              <div
                style={{
                  flexDirection: 'row',
                  display: 'flex',
                  padding: '10px',
                  backgroundColor: this.context.isDarkMode
                    ? '#15202b'
                    : '#eaeef0',
                }}
              >
                <button
                  onClick={this.increase.bind(this)}
                  disabled={this.state.plus}
                  style={{
                    border: 'none',
                    backgroundColor: this.context.isDarkMode
                      ? '#15202b'
                      : '#eaeef0',
                  }}
                >
                  <IconContext.Provider
                    value={{
                      color: this.context.isDarkMode
                        ? this.state.plus
                          ? '#a39e9e'
                          : '#fcfafa'
                        : this.state.plus
                        ? '#a39e9e'
                        : '#686968',
                    }}
                  >
                    <FaPlus size={20} />
                  </IconContext.Provider>
                </button>
                <button
                  onClick={this.decrease.bind(this)}
                  disabled={this.state.minus}
                  style={{
                    border: 'none',
                    backgroundColor: this.context.isDarkMode
                      ? '#15202b'
                      : '#eaeef0',
                  }}
                >
                  {' '}
                  <IconContext.Provider
                    value={{
                      color: this.context.isDarkMode
                        ? this.state.minus
                          ? '#a39e9e'
                          : '#fcfafa'
                        : this.state.minus
                        ? '#a39e9e'
                        : '#686968',
                    }}
                  >
                    <FaMinus size={20} />
                  </IconContext.Provider>
                </button>
              </div>
            </tbody>
          </table>
        </div>
      </div>
    );
  };
  public render() {
    return (
      <div>
        <div className='control-pane-dialog'>
          <div
            id='targetElement'
            className='col-lg-12 defaultDialog dialog-target'
          >
            <GridComponent
              id='gridShiftTemplate'
              dataSource={this.state.TemplateData}
              editSettings={this.editOptions}
              toolbar={this.toolbarOptions}
              ref={(g) => (this.grid = g)}
              filterSettings={this.FilterOptions}
              allowFiltering={true}
              allowPaging={true}
              height='calc(-220px + 100vh)'
              pageSettings={this.pageOptions}
              showColumnMenu={true}
              allowResizing={true}
              allowGrouping={true}
              allowExcelExport={true}
              showColumnChooser
              toolbarClick={this.toolbarClick.bind(this)}
              actionBegin={this.begin.bind(this)}
              gridLines={'Both'}
            >
              <ColumnsDirective>
                <ColumnDirective
                  field='rt_template_name'
                  headerText='Template Name'
                  width='25%'
                  textAlign='Left'
                />
                <ColumnDirective
                  field='rt_description'
                  headerText='Description'
                  width='25%'
                  textAlign='Left'
                />
                <ColumnDirective
                  field='Assignees'
                  headerText='Assignees'
                  width='25%'
                  textAlign='Left'
                />
              </ColumnsDirective>
              <Inject
                services={[
                  Edit,
                  Toolbar,
                  Filter,
                  Page,
                  ColumnChooser,
                  ExcelExport,
                  ColumnMenu,
                  Resize,
                  Group,
                ]}
              />
            </GridComponent>
            {this.state.hideDialog ? (
              <DialogComponent
                isModal={true}
                id='defaultdialog'
                width={'1400px'}
                height={500}
                showCloseIcon={true}
                animationSettings={this.animationSettings}
                visible={this.state.hideDialog}
                header='Template'
                buttons={this.buttons}
                open={this.dialogOpen.bind(this)}
                close={this.dialogClose.bind(this)}
                content={this.dialogComponentContent.bind(this)}
              ></DialogComponent>
            ) : null}
            {this.state.editDialog ? (
              <DialogComponent
                isModal={true}
                id='defaultdialog'
                width={'1400px'}
                height={500}
                showCloseIcon={true}
                animationSettings={this.animationSettings}
                visible={this.state.editDialog}
                header='Edit to template'
                buttons={this.buttonsForEdit}
                close={this.dialogClose.bind(this)}
                content={this.dialogComponentContent.bind(this)}
              ></DialogComponent>
            ) : null}
            {this.state.hideDialogDelete ? (
              <DialogComponent
                isModal={true}
                id='defaultDialogDelete'
                showCloseIcon={true}
                animationSettings={this.animationSettings}
                visible={this.state.hideDialogDelete}
                header='Confirmation'
                width={200}
                height={'auto'}
                buttons={this.buttonsDelete}
                open={this.dialogOpenDelete.bind(this)}
                close={this.dialogCloseDelete.bind(this)}
              >
                <div className='container'>
                  <div className='row'>
                    <span>Are you sure?</span>
                  </div>
                </div>
              </DialogComponent>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}
